/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/naming-convention */
import getCsrfHeader from "@sd-utility/csrf";
import { ATGSFLGetItemsResponse, SFLProduct } from "types/sfl/interfaces";
import { csrfAPI, sflAPI } from "./config";

let csrfToken = "";
const getCsrfToken = async (): Promise<{
  csrfToken: string;
}> => {
  try {
    // eslint-disable-next-line no-underscore-dangle
    // if (window.__product_listing_initial_state__.isLocal) {
    //   const csrfToken = getSessionConfNumber();
    //   return { csrfToken: csrfToken.sesionConfirmationNumber };
    // }
    const res = await csrfAPI().post("/getSessionConfirmationNumber");
    csrfToken = res.data.sessionConfirmationNumber;

    return { csrfToken };
  } catch {
    throw new Error("Could not retrieve csrf token");
  }
};

const getSFLItems = async () => {
  const res = await sflAPI().get<ATGSFLGetItemsResponse>("/list", {
    params: { _dynSessConf: csrfToken },
    headers: { ...getCsrfHeader() },
  });

  return res.data;
};

const handleGetCsrfToken = async (): Promise<void> => {
  try {
    await getCsrfToken();
  } catch (error) {
    console.error(error);
  }
};

const handleSFLItems = async (): Promise<void> => {
  try {
    if (typeof window !== "undefined") {
      const sflItems = await getSFLItems();

      if (sflItems?.savedProducts) {
        sessionStorage.setItem("sfl_product_list", JSON.stringify(sflItems));
      }
    }
  } catch (error) {
    console.log(error);
  }
};

const handleGetSFL = async () => {
  await handleGetCsrfToken();
  handleSFLItems();
};

const addProductToSaveForLater = async (productId: string) => {
  const saveForLaterData = await sflAPI().post<ATGSFLGetItemsResponse>(
    "/addProduct",
    undefined,
    {
      params: {
        _dynSessConf: csrfToken,
        productId,
      },
      headers: { ...getCsrfHeader() },
    },
  );
  return saveForLaterData.data;
};

const removeProductFromSaveForLater = async (productId: string) => {
  const saveForLaterData = await sflAPI().post<ATGSFLGetItemsResponse>(
    "/removeProduct",
    undefined,
    {
      params: {
        _dynSessConf: csrfToken,
        productId,
      },
      headers: { ...getCsrfHeader() },
    },
  );
  return saveForLaterData.data;
};

const getSavedProductsFromStorage = (): SFLProduct[] => {
  const sflItems = sessionStorage.getItem("sfl_product_list");
  return sflItems ? JSON.parse(sflItems).savedProducts : [];
};

const setSavedProductsToStorage = (savedProducts: SFLProduct[]) => {
  sessionStorage.setItem("sfl_product_list", JSON.stringify({ savedProducts }));
};

const addProductToSessionStorage = (
  savedProducts: SFLProduct[],
  productId: string,
) => {
  try {
    savedProducts.push({ productId });
    setSavedProductsToStorage(savedProducts);
  } catch (error) {
    console.log("Error adding product to SFL session storage");
  }
};

const removeProductFromSessionStorage = (
  savedProducts: SFLProduct[],
  productId: string,
) => {
  try {
    const productIndex = savedProducts.findIndex(
      (item: SFLProduct) => item.productId === productId,
    );
    if (productIndex !== -1) {
      savedProducts.splice(productIndex, 1);
      setSavedProductsToStorage(savedProducts);
    }
  } catch (error) {
    console.log("Error removing product from SFL session storage");
  }
};

export {
  addProductToSaveForLater,
  addProductToSessionStorage,
  getCsrfToken,
  getSFLItems,
  getSavedProductsFromStorage,
  handleGetSFL,
  removeProductFromSaveForLater,
  removeProductFromSessionStorage,
  setSavedProductsToStorage,
};
